import { CheckBox } from '@estee/elc-checkbox';
import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import * as classnames from 'classnames';
import { Body2 } from '@estee/elc-typography';
import { translate, ITranslationsCollection } from '@estee/elc-service';

export interface IProductNotifyMeNotice {
    acceptsTerms: boolean;
    translations?: ITranslationsCollection;
    onTermsCheckedChanged(value: boolean): void;
    gdprConfirmation?: boolean;
}

const ProductGdprNoticeWrapper = styled.div`
    position: relative;
`;

const ProductGdprNotice = styled.div`
    display: flex;
    align-items: flex-start;
`;

const productNotifyMeGdprNoticeLabelClassNames = classnames(
    'elc-product-notify-me-gdpr-notice-label',
    'js-product-notify-me-gdpr-notice-label'
);

const productNotifyMeGdprReadConfirmationClassNames = classnames(
    'elc-product-notify-me-gdpr-read-confirmation',
    'js-product-notify-me-gdpr-read-confirmation'
);

const productNotifyMeNoticeClassNames = classnames(
    'elc-product-notify-me-notice',
    'js-product-notify-me-notice'
);

const productNotifyMeNoticeWrapperClassNames = classnames(
    'elc-product-notify-me-notice-wrapper',
    'js-product-notify-me-notice-wrapper'
);

export const ProductNotifyMeNotice: React.FunctionComponent<IProductNotifyMeNotice> = translate([
    'gdprNoticeLabel',
    'gdprValidationText'
])(
    observer((props: IProductNotifyMeNotice) => {
        const {
            gdprNoticeLabel,
            gdprValidationText
        } = props.translations as ITranslationsCollection;
        const { gdprConfirmation = false } = props;

        return (
            <ProductGdprNoticeWrapper className={productNotifyMeNoticeWrapperClassNames}>
                <ProductGdprNotice className={productNotifyMeNoticeClassNames}>
                    <CheckBox
                        label=""
                        isChecked={props.acceptsTerms}
                        value=""
                        onChange={props.onTermsCheckedChanged}
                        data-test-id="terms-acceptance-check"
                    />
                    <Body2
                        dangerouslySetInnerHTML={{ __html: gdprNoticeLabel }}
                        className={productNotifyMeGdprNoticeLabelClassNames}
                    ></Body2>
                </ProductGdprNotice>
                {gdprConfirmation && (
                    <Body2 className={productNotifyMeGdprReadConfirmationClassNames}>
                        {gdprValidationText}
                    </Body2>
                )}
            </ProductGdprNoticeWrapper>
        );
    })
);
